/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs */

const en__field__enum_studyprograms_study_primary_school_teaching27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary School Teaching`)
};

const de__field__enum_studyprograms_study_primary_school_teaching27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Grundschulen`)
};

/**
* | output |
* | --- |
* | "Primary School Teaching" |
*
* @param {_Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_primary_school_teaching27 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Primary_School_Teaching27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_primary_school_teaching27(inputs)
	return de__field__enum_studyprograms_study_primary_school_teaching27(inputs)
});
export { _field__enum_studyprograms_study_primary_school_teaching27 as "_field__enum_studyPrograms_STUDY_PRIMARY_SCHOOL_TEACHING" }